import cn from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { TextButton } from '@bibliocommons/base-buttons';
import { ChevronRight as IconChevronRight } from '@bibliocommons/base-icons';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';

import {
  FullScreenOverlayBody,
  FullScreenOverlayHeader,
  FullScreenOverlayContent,
  FullScreenOverlayContainer
} from 'app/components/shared/FullScreenOverlay';
import Heading from 'app/components/shared/Heading';
import UniversalBibBriefContainer from 'app/components/bibs/shared/UniversalBibBrief/UniversalBibBriefContainer';

import { CONTENT_PROVIDER_IDS } from 'app/constants/BibConstants';
import { getRecommendationProviderDisplayName } from 'app/helpers/bib/bibHelpers';

import './MoreFromProvider.scss';

const MoreFromProvider = ({
  className,
  closeOverlay,
  metadataId,
  openOverlay,
  overlayKey,
  providerId,
  renderOverlayContent,
  showHeading
}) => {
  const providerDisplayName = getRecommendationProviderDisplayName(providerId);
  const triggerKey = `${overlayKey}-trigger`;

  return (
    <div className={cn('cp-more-from-provider', className)}>
      {showHeading && (
        <Heading tagName="h3" size="medium" variant>
          {providerDisplayName}
        </Heading>
      )}
      <TextButton className="overlay-trigger" dataKey={triggerKey} handleClick={openOverlay} inline leftAligned>
        <span aria-hidden>
          <FormattedMessage id="view_all_from_provider" values={{ provider: providerDisplayName }} />
        </span>
        <ScreenReaderMessage>
          <FormattedMessage id="sr_view_all_from_provider" values={{ provider: providerDisplayName }} />
        </ScreenReaderMessage>
        <IconChevronRight className="icon-chevron" />
      </TextButton>
      <FullScreenOverlayContainer dataKey={overlayKey} handleClose={closeOverlay} overlayKey={overlayKey}>
        <FullScreenOverlayBody className="cp-more-from-provider-overlay">
          <FullScreenOverlayHeader title={providerDisplayName} />
          <FullScreenOverlayContent size="medium">
            <div className="bib-brief">
              <UniversalBibBriefContainer metadataId={metadataId} />
            </div>
            {renderOverlayContent()}
          </FullScreenOverlayContent>
        </FullScreenOverlayBody>
      </FullScreenOverlayContainer>
    </div>
  );
};

MoreFromProvider.defautlProps = {
  className: '',
  showHeading: true
};

MoreFromProvider.propTypes = {
  className: PropTypes.string,
  closeOverlay: PropTypes.func.isRequired,
  metadataId: PropTypes.string.isRequired,
  openOverlay: PropTypes.func.isRequired,
  overlayKey: PropTypes.string.isRequired,
  providerId: PropTypes.oneOf(Object.values(CONTENT_PROVIDER_IDS)).isRequired,
  renderOverlayContent: PropTypes.func.isRequired,
  showHeading: PropTypes.bool
};

export default MoreFromProvider;
